/**
 * API client for access request endpoints.
 * Routes: /api/mgmt/requests
 */

import { apiFetch } from './client';

export interface AccessRequest {
  email: string;
  name: string;
  reason: string;
  requestedRole: 'user' | 'admin';
  status: 'pending' | 'approved' | 'denied';
  deniedReason?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRequestData {
  name: string;
  reason: string;
  requestedRole?: 'user' | 'admin';
}

export async function listPendingRequests(token: string): Promise<AccessRequest[]> {
  const data = await apiFetch<{ requests: AccessRequest[] }>('/api/mgmt/requests', token);
  return Array.isArray(data) ? data : (data.requests ?? []);
}

export async function submitAccessRequest(
  data: CreateRequestData,
  token: string,
): Promise<AccessRequest> {
  const resp = await apiFetch<{ request: AccessRequest }>('/api/mgmt/requests', token, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return resp.request ?? resp as unknown as AccessRequest;
}

export async function approveRequest(email: string, token: string): Promise<void> {
  await apiFetch<{ message: string }>(
    `/api/mgmt/requests/${encodeURIComponent(email)}/approve`,
    token,
    { method: 'POST' },
  );
}

export async function denyRequest(
  email: string,
  token: string,
  reason?: string,
): Promise<void> {
  await apiFetch<{ message: string }>(
    `/api/mgmt/requests/${encodeURIComponent(email)}/deny`,
    token,
    {
      method: 'POST',
      body: JSON.stringify({ reason }),
    },
  );
}
